<template>
    <b-row>
        <div class="col-sm-12 mt-3">
            <div class="marco_usuarios_panel">
                <table class="table table-sm table-striped table-bordered" style="font-size: 12px;">
                    <thead>
                        <tr>
                            <th style="width: 50%;">
                                Nombre
                            </th>
                            <th style="width: 15%;text-align: center;">
                                Usuario
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Bloquedo
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Super Usuario?
                            </th>
                            <th style="width: 15%;text-align: center;">
                                ...
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in lista_usuarios_panel" :key="index">
                            <td>
                                {{ item.nombre_completo }} {{ datos_usuario.id == item.id ? '(yo)' : '' }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.username }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.blocked | bloqueo }}
                            </td>
                            <td
                                :style="`text-align: center;${item.parametros.roles.includes('ROOT') ? 'background-color: #0fa553;color:white;' : ''}`">
                                {{ item.parametros.roles.includes('ROOT') | bloqueo }}
                            </td>
                            <td style="text-align: center;">
                                <button type="button" style="font-size: 9px;margin-right: 10px;"
                                    class="btn btn-sm btn-outline-dark" @click="abrir_modal_ficha(item)"><i
                                        class="fas fa-eye"></i></button>
                                <button type="button" style="font-size: 9px;"
                                    :disabled="item.parametros.roles.includes('ROOT')"
                                    class="btn btn-sm btn-outline-dark" @click="abrir_modal_permisos(item)"><i
                                        class="fas fa-lock"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="floating-button" @click="abrir_modal_formulario_nuevo_usuario">
            <button class="add-button">
                <i class="fas fa-user-plus"></i>
            </button>
        </div>

        <Formulario v-if="modal_formulario_nuevo_usuario" v-on:salir="cerrar_modal_formulario_nuevo_usuario" />
        <Permisos v-if="modal_permisos" v-on:salir="cerrar_modal_permisos" />
        <Ficha v-if="modal_ficha" :item="item_ficha" v-on:salir="cerrar_modal_ficha" />
    </b-row>
</template>

<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import Formulario from './Formulario.vue';
    import Permisos from './ModalPermisos.vue'
    import Ficha from './Ficha.vue'

    export default {
        name: 'ListaUsuarios',
        filters: {
            bloqueo: function (valor) {
                if (valor == 0) {
                    return 'No'
                } else {
                    return 'Si'
                }
            }
        },
        computed: {
            ...mapState(['lista_usuarios_panel', 'datos_usuario'])
        },
        components: {
            Formulario,
            Permisos,
            Ficha
        },
        data() {
            return {
                modal_formulario_nuevo_usuario: false,
                modal_permisos: false,
                modal_ficha: false,
                item_ficha: {}
            }
        },
        methods: {
            abrir_modal_formulario_nuevo_usuario() {
                this.modal_formulario_nuevo_usuario = true;
            },
            cerrar_modal_formulario_nuevo_usuario() {
                this.modal_formulario_nuevo_usuario = false;
            },
            abrir_modal_permisos(item) {
                this.set_usuario_seleccionado_permisos(item)
                this.modal_permisos = true;
            },
            cerrar_modal_permisos() {
                this.modal_permisos = false;
            },
            abrir_modal_ficha(item) {
                this.item_ficha = item;
                this.modal_ficha = true;
            },
            cerrar_modal_ficha() {
                this.modal_ficha = false;
            },
            ...mapActions(['obtener_lista_usuarios_panel']),
            ...mapMutations(['set_usuario_seleccionado_permisos'])
        },
        mounted() {
            // this.obtener_usuarios_panel();
            this.obtener_lista_usuarios_panel()
        },
    }
</script>

<style>
    .marco_usuarios_panel {
        width: 100%;
        height: calc(100vh - 160px);
        overflow: auto;
    }

    .floating-button {
        position: fixed;
        bottom: 30px;
        right: 30px;
        z-index: 998;
    }

    .add-button {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        background-color: orangered;
        border: none;
        color: white;
        cursor: pointer;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        transition: background-color 0.3s ease;
    }

    .add-button:hover {
        background-color: #ffa726;
        /* background-color: #0fa553; */
    }
</style>